import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { SET_WAZZUP_TYPE } from '../../Actions/Wazzup.js'

class WazzupFilter extends Component {
    render() {
        return (
            <div className="c-subnav c-subnav--filter">
                
                <div className="o-spacer"></div>
                <div className="c-subnav__inner">
                    <div className="c-subnav__items">
                        <a
                            className={this.props.wazzup_type === 'all' ? 'is-active': ''}
                            onClick={() => {
                                this.props.actions.SET_WAZZUP_TYPE('all')
                            }} 
                        >Iedereen</a>

                        <a
                            className={this.props.wazzup_type === 'friends' ? 'is-active': ''}
                            onClick={() => {
                                this.props.actions.SET_WAZZUP_TYPE('friends')
                            }} 
                        >Vrienden</a>
                        
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        wazzup_type: state.wazzup.wazzup_type,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({SET_WAZZUP_TYPE}, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WazzupFilter)


